import { Directive } from '@angular/core';

@Directive({
  selector: '[fcPrefix]',
  standalone: true,
  host: {
    class: 'fc-prefix',
  },
})
export class PrefixDirective {}
